export default {
    list: {
        title: "Employeurs",
        name: 'pointages',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: true,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                name: "Actions",
                buttons: [
                ],
            }
        },
        columns: [
            {
                name: "Employeur",
                elements: [{
                    items: [{
                        class: "",
                        name: "user",
                        elements: [{
                            items: [{
                                name: "fullName",
                                class: "font-bold text-gray-700",
                                icone: "contacts"
                            },
                            {
                                name: "username",
                                class: "font-light text-gray-700",
                                icone: "copyright"
                            }
                            ]
                        }]

                    },],
                },]
            },

            {
                name: "Role",
                elements: [{
                    items: [{
                        class: "",
                        name: "_id",
                        elements: [{
                            items: [{
                                name: "user",
                                name_1: "type",
                                class: "font-bold text-gray-700",
                                icone: ""
                            },
                                // {
                                //     name: "type",
                                //     class: "font-light text-gray-700",
                                //     icone: ""
                                // }
                            ]
                        }]

                    },],
                },]
            },

            {
                name: "NB de jours travaillés",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "daysPresence",
                        type: "text",
                    }],
                },]
            },

            {
                name: "NB de jours d'absences",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "daysAbsent",
                        type: "text",
                    }],
                },]
            },

            {
                name: "Salaire net",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "amount",
                        type: "text",
                    }],
                },]
            },

            {
                name: "Payment",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "payslip",
                        button: true,
                    }],
                },]
            },


            // {
            //     name: "Status",
            //     class: "text-center",
            //     elements: [{
            //         items: [{
            //             class: "border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none",
            //             name: "status",
            //             options: (item) => {
            //                 switch (item) {
            //                     case 'not applied':
            //                         return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
            //                         break;
            //                     case 'applied':
            //                         return "color:rgb(58 217 18); border-color: rgb(58 217 18);"
            //                         break;
            //                 }
            //             },
            //         }],
            //     }, ]
            // },

        ],
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-end",
            elements: [
                {
                    icone: "remove_red_eye",
                    color: "success",
                    key: 'read',
                    id: "",
                    role: true,
                    link: '/salaries/pointage/view',
                    tooltip: "Update",
                }
            ],
        },
        filters: {
            name: 'charges',
            hasFilterdate: true,
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "id,Amount ...",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [
                    {
                        label: "Roles",
                        key: "type",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Employeurs",
                        key: "user",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },

                    {
                        label: "Date",
                        key: "Range_date",
                        value: null,
                        placeholder: "Date Range ...",
                        type: "date_range",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    },
                ],
            },
        },
    },
}
